// Module
var code = `<div class="editor-mark-link">
	<div class="form-group">
		<label>Link</label>
		<input type="url" name="url" class="form-control input-url">
	</div>
	<div class="form-group">
		<label>Title</label>
		<input type="text" name="title" class="form-control input-title">
	</div>
	<div class="form-group">
		<label><input type="checkbox" name="target" value="_blank" class="select-target"> Open in new window</label>
	</div>
</div>
`;
// Exports
export default code;